import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useMemo, useState } from 'react';
import FlexibleCard from '../../../FlexibleCard';
import { FooterBlock, MetadataBlock, PreviewBlock, SnippetBlock, TitleBlock } from '../../../FlexibleCard/components/blocks';
import { metadataBlockCss } from './styled';
import { ActionName, ElementName, SmartLinkPosition } from '../../../../constants';
import { getSimulatedBetterMetadata, titleBlockOptions, PreviewBlockOptions, FlexibleCardUiOptions, FooterBlockOptions } from './utils';
import { withFlexibleUIBlockCardStyle } from './utils/withFlexibleUIBlockCardStyle';
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */
const FlexibleResolvedView = ({
  cardState,
  onClick,
  onError,
  onResolve,
  actionOptions,
  testId = 'smart-block-resolved-view',
  url,
  analytics
}) => {
  const [isPreviewBlockErrored, setIsPreviewBlockErrored] = useState(false);
  useEffect(() => {
    setIsPreviewBlockErrored(false);
  }, [url, cardState]);
  const {
    titleMetadata,
    topMetadata,
    bottomMetadata
  } = getSimulatedBetterMetadata(cardState.details);
  const footerActions = useMemo(() => [{
    name: ActionName.FollowAction,
    hideIcon: true
  }, {
    name: ActionName.PreviewAction,
    hideIcon: true
  }, {
    name: ActionName.DownloadAction,
    hideIcon: true
  }], []);
  return /*#__PURE__*/React.createElement(FlexibleCard, {
    analytics: analytics,
    appearance: "block",
    cardState: cardState,
    onClick: onClick,
    onError: onError,
    onResolve: onResolve,
    actionOptions: actionOptions,
    testId: testId,
    ui: FlexibleCardUiOptions,
    url: url
  }, /*#__PURE__*/React.createElement(TitleBlock, _extends({}, titleBlockOptions, {
    metadata: titleMetadata,
    subtitle: [{
      name: ElementName.Location
    }],
    metadataPosition: SmartLinkPosition.Top
  })), /*#__PURE__*/React.createElement(MetadataBlock, {
    primary: topMetadata,
    maxLines: 1,
    overrideCss: metadataBlockCss
  }), /*#__PURE__*/React.createElement(SnippetBlock, null), /*#__PURE__*/React.createElement(MetadataBlock, {
    primary: bottomMetadata,
    maxLines: 1,
    overrideCss: metadataBlockCss
  }), !isPreviewBlockErrored ? /*#__PURE__*/React.createElement(PreviewBlock, _extends({}, PreviewBlockOptions, {
    onError: () => {
      setIsPreviewBlockErrored(true);
    }
  })) : null, /*#__PURE__*/React.createElement(FooterBlock, _extends({}, FooterBlockOptions, {
    actions: footerActions
  })));
};
export default withFlexibleUIBlockCardStyle(FlexibleResolvedView);